import { toast } from "react-toastify";

export function onSuccess(message = "Success") {
  toast.success(message);
}

export function onError(message = "Something error!") {
  toast.error(message);
}
